<script setup>
import axios from 'axios';
import { ref } from 'vue';

import ContributorsTable from '~/common/components/ContributorsTable.vue';
import ErrorState from '~/common/components/ErrorState.vue';
import FilterCard from '~/common/components/FilterCard.vue';
import RoutePagination from '~/common/components/RoutePagination.vue';
import ThemedOverlay from '~/common/components/ThemedOverlay.vue';

const leaders = ref([]);
const busy = ref(true);
const error = ref(null);
const filterData = ref({
  search: '',
  fromDate: '',
  toDate: '',
  communityOnly: true,
  teamOnly: false,
  currentPage: 1,
});
const pageData = ref({
  perPage: 50,
  totalRows: 0,
});

const fetchData = async () => {
  busy.value = true;
  error.value = null;
  const query = {
    from_date: filterData.value.fromDate,
    to_date: filterData.value.toDate,
    community_only: filterData.value.communityOnly,
    team_only: filterData.value.teamOnly,
    page: filterData.value.currentPage,
  };
  const search = filterData.value.search;
  if (search.length > 0) {
    query.search = search;
  }

  try {
    const response = await axios.get(
      '/api/v1/leaderboard',
      { params: query },
    );
    const { records, metadata } = response.data;
    leaders.value = records;
    pageData.value = {
      perPage: metadata.per_page,
      totalRows: metadata.total_count,
    };
  } catch (e) {
    error.value = e;
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <ErrorState v-if="error" />
  <template v-else>
    <FilterCard
      v-model="filterData"
      show-community-only
      show-search
      @filter="fetchData"
    />

    <ThemedOverlay :show="busy">
      <ContributorsTable
        :contributors="leaders"
        :filter-data="filterData"
      />
      <RoutePagination
        v-model="filterData.currentPage"
        :total-rows="pageData.totalRows"
        :per-page="pageData.perPage"
      />
    </ThemedOverlay>
  </template>
</template>
